// extracted by mini-css-extract-plugin
export default {"productCarousel":"t1-z"};